// Recovered compiled webpack factory 29658. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e, t) {
    return (void 0 === t && (t = !0), e.pathname + e.search + (t ? e.hash : ""));
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "createHrefFromUrl", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
